import { useEffect, useState } from 'react';
import serviceMethods from '../../service';
import Heading from '@Components/Heading';

const OmniAgent = () => {
  const [iFrame, setIFrame] = useState(null);

  const fetchOmniAgent = async () => {
    const res = await serviceMethods.getOmniAgent();
    const data = await res.json();
    const { url } = data;
    setIFrame(url);
  };

  useEffect(() => {
    fetchOmniAgent();
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Heading>OnePoint Insights</Heading>
      </div>

      <div className="flex h-full w-full flex-col items-center">
        {iFrame && (
          <iframe
            className="rounded-lg border-1"
            title="OmniAgent"
            width="100%"
            height="680px"
            src={iFrame}
          />
        )}
      </div>
    </div>
  );
};

export default OmniAgent;
